<template>
  <div class="analytics network-analytics">
    <filter-bar :timeframe="timeframe" @change="setTimeframe" />

    <stats
      :data="basicMetrics"
      :props="basicMetricProps"
      :min-width="minWidth"
    />

    <treemap
      v-if="dimensions"
      :items="treemapItems"
      :width="dimensions.width"
      :height="800"
      :min-width="minWidth"
      :type="'account'"
    />

    <line-chart
      v-if="dimensions && items"
      :items="items"
      :width="dimensions.width"
      :timeframe-labels="timeframeLabels"
      :height="400"
      :min-width="minWidth"
      :timeframe="timeframe"
    />

        <ranking-list
      title="Top Articles"
      :items="
        (cogData ? cogData.topArticlesByTimeframe[timeframe] : []).map((tr) => ({
          id: tr.articleId,
          name: tr.article ? tr.article.title : '-',
          value: tr.views,
          lastValue: 0,
          diffNum: false,
          diffStr: '',
          webDownloads: tr.downloads || 0,
          emailViews: 0,
          sendgridOpened: 0,
          valueRank: 1,
          lastValueRank: -1,
          change: 0,
          engagement: 4,
          position: 1,
          account: '',
          account_id: 0,
          channel: tr.article ? tr.article.channel : '-',
          channel_id: tr.article ? tr.article.channelId : '-',
          analyst: tr.article ? tr.article.primaryAnalyst || '-' : '-',
          analyst_id: tr.article && tr.article.analystIds ? tr.article.analystIds[0] : '-',
          companies: null,
          email: '',
        }))
      "
      :active-id="data.id"
      :settings="{
        title: 'Top Articles',
        path: 'articles',
        colWidth: 12,
        activeEnabled: true,
        cols: ['name', 'channel', 'analyst', 'webDownloads', 'engagement'],
        type: 'infinity-rank',
      }"
      :client-width="clientWidth"
    />

    <!-- <filter-buttons
      :items="metricProps"
      :active="metricActive"
      :loading="metricItemsLoading"
      @change="setMetricActive"
    />

    <treemap
      v-if="dimensions"
      :items="metricActive in metricItems ? metricItems[metricActive] : null"
      :width="dimensions.width"
      :height="800"
      :min-width="minWidth"
      :type="metricActive"
      :enable-link="getMetric(metricActive).link"
      :show-title="false"
      mode="surface"
    /> -->
    <div style="border-bottom: 1px solid #ccc; margin: 1rem 0">&nbsp;</div>
    <TopAnalysts v-if="cogData" :timeframe="timeframe" :data="cogData" />
    <TopChannels v-if="cogData" :timeframe="timeframe" :data="cogData" />
    <TopUsers v-if="cogData" :timeframe="timeframe" :data="cogData" />
  </div>
</template>

<script>
import AnalyticsMixin from '@/analytics/mixins/AnalyticsMixin'
import TimeframeMixin from '@/analytics/mixins/TimeframeMixin'

import FilterBar from '@/components/FilterBar'
import FilterButtons from '@/components/FilterButtons'
import Stats from '@/components/Stats'
import LineChart from '@/components/d3/LineChart'
import Treemap from '@/components/d3/Treemap'
import RankingList from '@/components/RankingList'
import TopChannels from './TopChannels.vue'
import TopAnalysts from './TopAnalysts.vue'
import TopUsers from './TopUsers.vue'


export default {
  components: {
    FilterBar,
    RankingList,
    Stats,
    FilterButtons,
    LineChart,
    Treemap,
    TopChannels,
    TopAnalysts,
    TopUsers,
  },

  mixins: [AnalyticsMixin, TimeframeMixin],

  async mounted() {
    await this.loadData('dashboard', this.timeframe)
  },

  data() {
    return {
      analyticsType: 'network',
      basicMetricProps: ['emailOpens', 'emailClicks', 'webViews'],
    }
  },

  computed: {
    timeframeLabels() {
      if (!this.cogData) {
        return []
      }

      return this.cogData.series[this.timeframe].webViewsDaily.map((item) => item.date)
    },

    items() {
      const items = this.cogData
      console.log('ohno', items)
      if (!items) {
        return {
          key: 'webViews',
          val: [],
          name: 'Web views',
        }
      }

      return { webViews: items.series[this.timeframe].webViewsDaily.map((d) => d.value) }
    },
  },
  watch: {
    timeframe: function (timeframe, oldData) {
      // this.loadData(timeframe)
      if (this.cogData) {
        this.treemapItems = this.cogData.engagement[
          this.timeframe
        ].accounts.map((ae) => ({
          id: ae.id.toString(),
          name: ae.name,
          value: ae.value,
          lastValue: ae.lastValue,
          diffNum: ae.difference,
          diffStr: ae.differenceText,
          valueRank: ae.rank,
          lastValueRank: ae.prevRank,
          change: ae.rankChange,
          position: ae.rank,
        }))
        this.basicMetrics = this.cogData.basicMetrics[this.timeframe].totals
      }
    },

    cogData() {
        this.treemapItems = this.cogData.engagement[
          this.timeframe
        ].accounts.map((ae) => ({
          id: ae.id.toString(),
          name: ae.name,
          value: ae.value,
          lastValue: ae.lastValue,
          diffNum: ae.difference,
          diffStr: ae.differenceText,
          valueRank: ae.rank,
          lastValueRank: ae.prevRank,
          change: ae.rankChange,
          position: ae.rank,
        }))
        this.basicMetrics = this.cogData.basicMetrics[this.timeframe].totals

    },

    keenAnalyses: function (newData, oldData) {
      if (newData !== null) {
        // this.constructBasicMetrics()
        // this.calcArticles()
        // console.log('final object', this.basicMetrics)

        // this.readership = constructReadership(
        //   newData,
        //   this.lineChartSources,
        //   this.analyticsType
        // )
        // console.log('READERSHIP', this.readership)
        // console.log('LABELS', this.timeframeLabels)

        // this.constructTreemap()
        this.constructMetricItems().then((resp) =>
          this.constructMetricItemsOthers()
        )
      }
    },
    metricActive: function (newdata, oldData) {
      this.constructMetricItems()
    },
  },
}
</script>
